(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        if (!this.disclosure) return;

        // Delay initial reset to ensure theme object is available
        requestAnimationFrame(() => {
          this.reset(false);
        });
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        if (!this.disclosure || !this.toggle) return;

        try {
          // Add null check for theme and mediaQueries
          if (!theme || !theme.mediaQueries || !theme.mediaQueries.md) return;

          const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
          const isConfirmNewsletter =
            !isLargeScreen &&
            window.location.hash === '#footer-signup_form' &&
            this.querySelector('#footer-signup_form') !== null;

          this.disclosure.open = isLargeScreen || isConfirmNewsletter;

          if (isLargeScreen) {
            this.toggle.setAttribute('tabindex', '-1');
          } else {
            this.toggle.removeAttribute('tabindex');
          }
        } catch (err) {
          console.warn('Error in FooterMenu reset:', err);
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
